import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import { getData } from 'clients/Clients';
import { getCampaignListV2 } from 'clients/MarketingClient';
import clsx from 'clsx';
import { useAuth } from 'context/Auth';
import useOnScreen from 'hooks/useOnScreen';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useEffect, useRef, useState } from 'react';
import { getNanoBanners } from 'services/WebService';
import ImageFallback, { ImageFallbackBanner, ImageFallbackStatic } from 'utils/ImageFallback';
import { getLinkCDNImage } from 'utils/ImageUtils';
import { debounceFunc300 } from 'utils/debounce';
import gtag from 'utils/gtag';
import styles from './styles.module.css';

export default function NanoBanner({ dataShowBoxYir }) {
  const { user } = useAuth();
  const [bannerNano, setBannerNano] = useState([]);
  const [listCampaign, setListCampaign] = useState([]);

  useEffect(() => {
    (async () => {
      if (user?.customerID) {
        const fetchData = async () => {
          const res = await getCampaignListV2({
            q: JSON.stringify({
              platform: 'WEB',
            }),
            provinceCode: user.provinceCode,
            limit: 20,
          });

          const campaigns = getData(res);
          let newList = [];
          if (campaigns.length > 3) {
            if (dataShowBoxYir && dataShowBoxYir.campaignBoxId) {
              newList = campaigns.filter((x) => x.campaignBoxID !== dataShowBoxYir.campaignBoxId);
            } else {
              newList = campaigns.slice(0, 3);
            }
          } else {
            newList = campaigns;
            if (dataShowBoxYir && dataShowBoxYir.campaignBoxId) {
              newList = campaigns.filter((x) => x.campaignBoxID !== dataShowBoxYir.campaignBoxId);
            }
          }
          setListCampaign(newList);
        };
        await fetchData();
      }
    })();
  }, [user?.customerID, dataShowBoxYir]);

  useEffect(() => {
    (async () => {
      if (!user?.provinceCode) return;

      const banners = await getNanoBanners({ provinceCode: user?.provinceCode, customerID: user?.customerID });
      setBannerNano(banners);
    })();
  }, [user?.provinceCode, user?.customerID]);

  const nanoRefs = useRef();
  const visible = useOnScreen(nanoRefs);
  useEffect(() => {
    if (visible) {
      debounceFunc300(() => {
        if (bannerNano.length === 0) return;
        gtag.showNanobanner(bannerNano[0]);
        listCampaign?.forEach((item) => {
          gtag.showCampaignbox(item);
        });
      });
    }
  }, [visible, bannerNano]);

  return (
    <div className={styles.containerBanner} ref={nanoRefs}>
      <div className={styles.containerImage}>
        {bannerNano[0]?.imgURL ? (
          <div>
            <ImageBanner banner={bannerNano[0]} />
          </div>
        ) : (
          <ImageFallbackStatic
            src={`${process.env.NEXT_PUBLIC_CDN_PREFIX || ''}/images/home/nanoBanner.png`}
            width={1200}
            objectFit="cover"
            layout="fill"
          />
        )}
      </div>
      <div className={clsx(styles.rightContainer, listCampaign?.length < 3 && styles.rightContainerSliderLessThen)}>
        {listCampaign?.map((x) => (
          <div key={x.campaignBoxID}>
            <Event data={x} />
          </div>
        ))}
      </div>
    </div>
  );
}

function ImageBanner({ banner }) {
  const router = useRouter();

  function handleClickBannerNano(e, item) {
    e.preventDefault();
    gtag.clickNanobanner(item?.name, item?.targetURL);
    router.push(item?.targetURL);
  }

  return (
    <Link href={banner?.targetURL || '#'} passHref prefetch={false}>
      <a onClick={(e) => handleClickBannerNano(e, banner)}>
        <ImageFallbackBanner src={banner?.imgURL} width={1200} objectFit="cover" layout="fill" />
      </a>
    </Link>
  );
}

function Event({ data }) {
  const router = useRouter();

  const handleClick = (e, item) => {
    e.preventDefault();
    gtag.clickCampaignbox(item.title, item.url);
    router.push(item.url);
  };

  return (
    <Link href={data?.url} passHref legacyBehavior prefetch={false}>
      <a onClick={(e) => handleClick(e, data)} className={clsx(styles.eventContainer)}>
        <Tooltip placement="top" title={data?.typeLabel || ''}>
          <Typography className={styles.titleEvent}>{data?.typeLabel || ''}</Typography>
        </Tooltip>
        <div className={styles.wrapperIcon}>
          <ImageFallback objectFit="contain" width="100%" src={data?.icon} alt="icon voucher" height="32" />
        </div>
        <div className={styles.wrapperViewMore}>
          {data?.subTitle && <span className={styles.wrapperSubTitle}>{data?.subTitle}</span>}
          <span className={styles.titleNanoBanner}>{data?.title}</span>
          <Typography className={styles.viewMore}> {data?.cta || 'Xem thêm'}</Typography>
        </div>
      </a>
    </Link>
  );
}
